import { Dropdown } from 'antd'

export default function MyDropdown({
  overlay = false,
  placement = 'bottom',
  trigger = ['click'],
  children,
  ...props
}) {
  return (
    <Dropdown
      overlayClassName="dropdowm-custom"
      trigger={trigger}
      overlay={overlay}
      placement={placement}
      {...props}
    >
      {children}
    </Dropdown>
  )
}
